import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { displayBooleanString } from 'ctm-util-functions';
import { SummaryTable } from '../summary_table';
import { getFinanceLabel, getPreviousInsurerLabel, getUsageTypeLabel } from '../../products/summary/common/details/cover_details';

const path = 'accident_hail_damage';

const _SummaryCoverDetails = (props) => {
    const { damaged, finance, currentlyInsured, previousInsurer, annualKilometres, useType, isUpdated } = props;

    const coverDetails = [
        {
            title: 'Unrepaired damage',
            value: displayBooleanString(damaged) ?? 'No'
        },
        {
            title: 'Finance',
            value: getFinanceLabel(finance)
        },
        {
            title: "Approx km's /p year",
            value: annualKilometres
        },
        {
            title: 'Vehicle usage',
            value: getUsageTypeLabel(useType)
        },
        {
            title: 'Currently insured',
            value: displayBooleanString(currentlyInsured) ?? 'No'
        },
        {
            title: 'Current insurer',
            value: previousInsurer ? getPreviousInsurerLabel(previousInsurer) : 'No'
        }
    ];

    return (
        <SummaryTable
            path={path}
            isUpdated={isUpdated}
            titleLabel={`Cover Details ${isUpdated ? '- Updated' : ''}`}
            tableContent={coverDetails}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        damaged: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'damaged']),
        finance: quoteFormSelector(state).getIn(['coverDetail', 'financeType']),
        currentlyInsured: quoteFormSelector(state).getIn(['coverDetail', 'currentlyInsured']),
        previousInsurer: quoteFormSelector(state).getIn(['coverDetail', 'previousInsurer']),
        annualKilometres: quoteFormSelector(state).getIn(['coverDetail', 'annualKilometres']),
        useType: quoteFormSelector(state).getIn(['coverDetail', 'useType']),
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryCoverDetails.propTypes = {
    damaged: PropTypes.string,
    securityFeatures: PropTypes.string,
    finance: PropTypes.string,
    currentlyInsured: PropTypes.string,
    previousInsurer: PropTypes.string,
    annualKilometres: PropTypes.string,
    useType: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryCoverDetails = connect(
    mapStateToProps,
)(_SummaryCoverDetails);

export { _SummaryCoverDetails, SummaryCoverDetails };
